import { IParsedWhitelabel } from '@/Interfaces/Whitelabels/Whitelabel.interface';
import ExportIcon from '@/components/Icons/ExportIcon';
import { Button } from '@mui/material';
import { SxProps, Theme } from '@mui/system';
import { useCallback } from 'react';

interface IProps {
  sx?: SxProps<Theme>;
  row: IParsedWhitelabel;
  onClick: (row: IParsedWhitelabel) => void;
}

const ViewButton = ({ sx, row, onClick }: IProps) => {
  const onActionClick = useCallback(() => {
    onClick(row);
  }, [onClick, row]);

  return (
    <Button
      variant='outlined'
      color='primary'
      sx={{
        minHeight: '29px',
        width: '68px',
        padding: 0,
        borderRadius: '32px',
        textWrap: 'nowrap',
        ...sx,
      }}
      onClick={onActionClick}
    >
      <ExportIcon className='w-[12px] mr-[4px]' />
      <span>View</span>
    </Button>
  );
};

export default ViewButton;
